import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';


export const Subscription: ITypeSpecificPolicy<types.Subscription> = {
  fields: {
    notificationPosted: {
      merge: (existing, incoming, { cache }) => {
        cache.modify<types.Query>({
          fields: {
            notifications: (notifications) => {
              return [
                ...notifications ?? [],
                incoming
              ];

            }
          }
        });
        return incoming;
      }
    }
  }
};
